import React, {useEffect} from 'react';
import {Outlet} from "react-router-dom";
import Box from "@mui/material/Box";
import useZibi from "../../zibi/UseZibi";
import {permissionsMap} from "../../maps/permissionsMap";
import CommonLayout, {DrawerHeader} from "./CommonLayout";
import {api} from "../../maps/data.js";

const AdminLayout = () => {
    const [user] = useZibi('user');
    const [, set_sensorStatuses] = useZibi('sensorStatuses');

    const role = user?.role?.[0];
    const sideMenuData = permissionsMap[role]?.sideMenu;
    const getStatusesPermission = permissionsMap[role]?.getSensorStatuses;

    const getStatuses = () => {
        api({
            type: "getSensorStatuses",
            data: {}
        }).then(data => {
            const temp = {};
            data.forEach(sens => {
                temp[sens._id] = sens;
            });
            set_sensorStatuses(temp);
        });
    };

    useEffect(() => {
        const reloadPage = () => {
            window.location.reload();
        };

        // Set interval to reload the page every 15 minutes (900000 milliseconds)
        const intervalId = setInterval(reloadPage, 900000);
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        if (getStatusesPermission) {
            getStatuses();
            const interval = setInterval(() => {
                getStatuses();
            }, 60000);
            return () => clearInterval(interval);
        }
    }, []);

    return (
        <CommonLayout
            sideMenuData={sideMenuData}
            account={user}
        >
            <Box component="main" sx={{flexGrow: 1, p: 3, padding: 0}}>
                <DrawerHeader/>
                <div style={{width: '100%', height: '90vh'}}>
                    <Outlet/>
                </div>
            </Box>
        </CommonLayout>
    );
};

export default AdminLayout;